import { DEFAULT_LOCALE, useErrorHandler, useLocaleData } from 'components/root/intl-provider/intl-provider.hooks';

import React, { ComponentProps } from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';
import { useLocale } from 'shared/hooks';
import { DEFAULT_RICH_TEXT_ELEMENTS } from './rich-text-elements';

interface IntlProviderProps extends Partial<ComponentProps<typeof ReactIntlProvider>> {
  children: React.ReactNode;
}

export const IntlProvider: React.FC<IntlProviderProps> = ({ children, ...props }: IntlProviderProps): JSX.Element => {
  const userLocale = useLocale();

  const { locale, messages } = useLocaleData(userLocale);
  const handleError = useErrorHandler();

  return (
    <ReactIntlProvider
      messages={messages}
      locale={locale}
      defaultLocale={DEFAULT_LOCALE}
      defaultRichTextElements={DEFAULT_RICH_TEXT_ELEMENTS}
      onError={handleError}
      {...props}
    >
      {children}
    </ReactIntlProvider>
  );
};
